import { $getFiltersRequestType } from '@shared/types';
import { z } from 'zod';

export const $Company = z.object({
  id: z.number(),
  name: z.string(),
  type: z.string(),
  nif: z.string(),
  nccVerified: z.boolean().nullable().optional(),
  cityId: z.number(),
  description: z.string(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  activitySphereIds: z.array(z.number()),
  city: z.object({
    id: z.number(),
    name: z.string(),
    code: z.string(),
    countryCode: z.string(),
  }),
  manager: z.object({
    createdAt: z.string(),
    email: z.string(),
    id: z.number(),
    isActive: z.boolean(),
    profile: z.object({
      id: z.number(),
      firstName: z.string(),
      lastName: z.string(),
      phone: z.string().nullable(),
      position: z.string().nullable(),
    }),
    updatedAt: z.string(),
  }),
  activitySpheres: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
    })
  ),
  economicActivities: z.array(
    z.object({
      id: z.number(),
      code: z.string(),
      name: z.string(),
    })
  ),
  rating: z.number().nullable(),
  level: z.enum(['iron', 'bronze', 'silver', 'gold', 'platinum']).nullable(),
});
export type Company = z.infer<typeof $Company>;

// export const $RegionForCreate = z.union([
//   z.object({
//     existing: z
//       .object({
//         id: z.number().optional(),
//       })
//       .optional(),
//     new: z
//       .object({
//         name: z.string().optional(),
//       })
//       .optional(),
//   }),
//   z
//     .object({
//       existing: z.array(z.number()).optional(),
//       new: z.array(z.string()).optional(),
//     })
//     .optional(),
// ]);
// export type RegionForCreate = z.infer<typeof $RegionForCreate>;

// Для компаний API ожидает плоское поле cityId
export const $CityId = z.number();
export type CityId = z.infer<typeof $CityId>;

export const $ActivitySphereForCreate = z.object({
  existing: z.array(z.number()),
  new: z.array(z.string()),
});
export type ActivitySphereForCreate = z.infer<typeof $ActivitySphereForCreate>;

export const $UpdateCompanyParams = z.object({
  name: z.string(),
  type: z.string().nullable(),
  nif: z.string(),
  cityId: $CityId.nullable().optional(),
  description: z.string(),
  managerId: z.number(),
  economicActivitiesIds: z.array(z.number()),
});
export type UpdateCompanyParams = z.infer<typeof $UpdateCompanyParams>;

export const $CompanyType = z.object({
  id: z.number(),
  value: z.string(),
  title: z.string(),
});
export type CompanyType = z.infer<typeof $CompanyType>;

export const $GetCompanyTypesResponse = z.array($CompanyType);
export type GetCompanyTypesResponse = z.infer<typeof $GetCompanyTypesResponse>;

export const $GetCompaniesRequest = $getFiltersRequestType(z.object({}));
export type GetCompaniesRequest = z.infer<typeof $GetCompaniesRequest>;

export const $CreateCompanyParams = z.object({
  name: z.string(),
  type: z.string(),
  nif: z.string(),
  cityId: $CityId,
  description: z.string(),
  managerId: z.number(),
  activitySpheres: $ActivitySphereForCreate,
});
export type CreateCompanyParams = z.infer<typeof $CreateCompanyParams>;

export const $UpdateCompanyActivityParams = z.object({
  isActive: z.boolean(),
});
export type UpdateCompanyActivityParams = z.infer<
  typeof $UpdateCompanyActivityParams
>;

export const $UpdateCompanyActivityResponse = z.object({
  isActive: z.boolean(),
});
export type UpdateCompanyActivityResponse = z.infer<
  typeof $UpdateCompanyActivityResponse
>;

export const $VerifyCompanyNccParams = z.object({
  ncc: z.string(),
});
export type VerifyCompanyNccParams = z.infer<typeof $VerifyCompanyNccParams>;

export const $VerifyCompanyNccResponse = z.object({
  nccVerified: z.boolean().nullable(),
});
export type VerifyCompanyNccResponse = z.infer<
  typeof $VerifyCompanyNccResponse
>;

export const $ConfirmCompanyNccResponse = z.object({
  nccVerified: z.boolean(),
});
export type ConfirmCompanyNccResponse = z.infer<
  typeof $ConfirmCompanyNccResponse
>;
